import React from "react";
import CalendarListPageContent from "../../Components/TemplateList/CalendarListPageContent";
const CalendarListPage = () => {
    return React.createElement(CalendarListPageContent, { category: '' });
};
export default CalendarListPage;
